// extracted by mini-css-extract-plugin
export default {"inputsWrapper":"style_inputsWrapper__EvbPc"};